module.exports = __webpack_public_path__ + "img/banner-image-14a72ec7.png";